import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = ["value", "onBlur", "onFocus"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Укажите начало ", -1)
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = ["disabled", "value", "onBlur", "onFocus"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Укажите конец ", -1)
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12 text-center" }

import { onMounted, reactive, computed, ref } from "vue";
import { ORDER_TYPE, ORDER_TYPE_COLLECTION } from '@depo/constants/employee';
import { useModal } from "@/composables/useModal";
import api from "@/api";
import moment from 'moment-timezone';
import { DatePicker } from 'v-calendar';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeOrderModal',
  props: {
    id: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const props = __props;

const modal = useModal(props.id);
const employees = ref([]);
const orderTypes = ORDER_TYPE_COLLECTION.map(o => ({ id: o, name: o }));

const state = reactive({
    startsAt: '',
    endsAt: '',
    type: '',
    comment: '',
    employeeId: '',
    title: '',
    btn: '',
    visibleErrors: false,
    loader: false,
});
const isEmployeeIdError = computed(() => !state.employeeId);
const isTypeError = computed(() => !state.type);
const isStartsAtError = computed(() => !state.startsAt);
const isEndsAtError = computed(() => state.type !== ORDER_TYPE.DISMISSAL ? !state.endsAt : false);

const errors = computed(() => {
    return isStartsAtError.value || isEndsAtError.value || isEmployeeIdError.value || isTypeError.value;
});

onMounted(() => {
    console.log(modal.data.employeeOrder);
    if (modal.data.type === 'add') {
        state.title = 'Создать приказ';
        state.btn = 'Сохранить';
    } else {
        state.title = 'Редактировать приказ';
        state.btn = 'Сохранить';
        state.startsAt = modal.data.employeeOrder.startsAt;
        state.type = modal.data.employeeOrder.type;
        state.employeeId = modal.data.employeeOrder.employeeId;
        state.endsAt = modal.data.employeeOrder.endsAt;
        state.comment = modal.data.employeeOrder.comment;
    }
    api.employees.get().then((r: any) => {
        employees.value = r.data?.map((em: any) => ({
            ...em,
            name: `${em.employeeName} (${em.employeePost})`,
        }));
    });
});

function onEmployeeSelect(_c: any) {
    state.employeeId = _c.id;
}

function onTypeSelect(_c: any) {
    state.type = _c.id;
}

function send() {
    if (errors.value) {
        state.visibleErrors = true;
    } else {
        state.visibleErrors = false;
        state.loader = true;
        if (modal.data.type === 'add') {
            api.employeeOrder.create({
                startsAt: state.startsAt,
                ...(!!state.endsAt && {
                    endsAt: state.endsAt,
                }),
                employeeId: state.employeeId,
                comment: state.comment,
                type: state.type,
            }).then((r: any) => {
                if (r.data) {
                    modal.ok(r.data);
                }
            }).finally(() => state.loader = false);
        } else {
            api.employeeOrder.update(modal.data.employeeOrder.id, {
                startsAt: state.startsAt,
                ...(!!state.endsAt && {
                    endsAt: state.endsAt,
                }),
                employeeId: state.employeeId,
                comment: state.comment,
                type: state.type,
            }).then((r: any) => {
                if (r.data) {
                    modal.ok(r.data);
                }
            }).finally(() => state.loader = false);
        }
    }
}

function ok() {
    modal.ok({
        asd: 123,
    });
}

function close() {
    modal.close();
}

function cancel() {
    modal.cancel({
        zxc: 123,
    });
}

return (_ctx: any,_cache: any) => {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: __props.id,
    size: "modal-xl",
    title: state.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _withModifiers(send, ["prevent"])
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите сотрудника",
              label: "Сотрудник",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "is-invalid": state.visibleErrors && isEmployeeIdError.value,
                  options: employees.value,
                  placeholder: "Сотрудник",
                  searchable: true,
                  values: [state.employeeId],
                  onOnSelected: onEmployeeSelect
                }, null, 8, ["is-invalid", "options", "values"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите тип приказа",
              label: "Тип приказа",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "is-invalid": state.visibleErrors && isTypeError.value,
                  options: _unref(orderTypes),
                  placeholder: "Приказ",
                  searchable: true,
                  values: [state.type],
                  onOnSelected: onTypeSelect
                }, null, 8, ["is-invalid", "options", "values"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите начало",
              label: "Начало",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DatePicker), {
                  modelValue: state.startsAt,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.startsAt) = $event)),
                  as: "",
                  readonly: "",
                  timezone: 'Asia/Almaty',
                  class: "inline-block h-full",
                  is24hr: true,
                  mode: "date"
                }, {
                  default: _withCtx(({ inputValue, togglePopover }) => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("input", {
                        class: _normalizeClass(["form-control", { 'is-invalid': isStartsAtError.value && state.visibleErrors, 'bg-white': true }]),
                        value: inputValue,
                        onBlur: ($event: any) => (togglePopover()),
                        onFocus: ($event: any) => (togglePopover())
                      }, null, 42, _hoisted_6),
                      _hoisted_7
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите конец",
              label: "Конец",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DatePicker), {
                  modelValue: state.endsAt,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.endsAt) = $event)),
                  as: "",
                  readonly: "",
                  timezone: 'Asia/Almaty',
                  class: "inline-block h-full",
                  is24hr: true,
                  mode: "date"
                }, {
                  default: _withCtx(({ inputValue, togglePopover }) => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("input", {
                        class: _normalizeClass(["form-control", { 'is-invalid': isEndsAtError.value && state.visibleErrors, 'bg-white': true }]),
                        disabled: state.type === _unref(ORDER_TYPE).DISMISSAL,
                        value: inputValue,
                        onBlur: ($event: any) => (togglePopover()),
                        onFocus: ($event: any) => (togglePopover())
                      }, null, 42, _hoisted_9),
                      _hoisted_10
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Примечание",
              label: "Примечание"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.comment,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.comment) = $event)),
                  placeholder: "Примечание"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(state.btn), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})